import PropTypes from 'prop-types';
import Link from '@activebrands/core-web/components/Link';
import ScrollableBox from '@activebrands/core-web/components/ScrollableBox';
import { styled } from '@activebrands/core-web/libs/styletron';
import textStyles from 'config/branding/textStyles';

const List = styled('ul', {
    display: 'flex',
    whiteSpace: 'nowrap',
    borderBottom: ['1px solid var(--color-border-checkout-subtle)', null, null, null, null, 'none'],
    paddingBottom: '12px',

    // Adds the same space as gap in front and after
    '::before': {
        content: '""',
        display: 'block',
        minWidth: 'var(--margin-content)',
        height: '10px',
    },
    '::after': {
        content: '""',
        display: 'block',
        minWidth: 'var(--margin-content)',
        height: '10px',
    },
});

const Item = styled('li', ({ $active }) => ({
    color: $active ? 'var(--color-text-checkout-steps-active)' : 'var(--color-text-checkout-steps)',
    textDecoration: $active ? 'underline' : 'none',
    cursor: $active ? 'pointer' : 'default',
    ...textStyles['Misc/12_110_-015'],
    ':not(:last-of-type)::after': {
        content: "'-'",
        display: 'inline-block',
        margin: '0 2px',
    },
}));

const StepList = ({ items = [] }) => {
    if (!items?.length) {
        return null;
    }

    return (
        <ScrollableBox
            $style={{
                width: '100%',
                marginTop: ['16px', null, null, null, null, '12px'],
            }}
            scrolldirection="horizontal"
        >
            <List>
                {items.map(({ label, to, active, ...rest }) => (
                    <Item $active={active} key={label} {...rest}>
                        {to ? <Link to={to}>{label}</Link> : label}
                    </Item>
                ))}
            </List>
        </ScrollableBox>
    );
};

StepList.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            active: PropTypes.bool,
            label: PropTypes.string,
            to: PropTypes.string,
        })
    ),
};

export default StepList;
